
import { DatePipe } from "@angular/common";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ClientModel } from "./client.model";
import { ProductModel } from "./product.model";
import { UserModel } from "./user.model";

export class ShippingArrivalModel {
    arrivalId : string;
    courierId : string;
    trackingNo : string;
    rmaCode: string;
    arrivalDate : DatePipe;
    clientId : string;
    note : string;
    createBy: string;
    createTime : DatePipe;

    public static getFormGroup()
    {
        var form: FormGroup = new FormGroup({
            arrivalId: new FormControl(null),
            courierId: new FormControl(null, Validators.required),
            trackingNo: new FormControl(null),
            rmaCode :  new FormControl(null),
            arrivalDate: new FormControl(new Date()),
            clientId: new FormControl(null),
            note: new FormControl(null),
            createBy: new FormControl(null),
            createTime: new FormControl(null)
        });
        return form;
    }

    public static initializeFormGroup(form){

        form.setValue({
            arrivalId : null,
            courierId : null,
            trackingNo: null,
            rmaCode: null,
            arrivalDate : null,
            clientId : null,
            note : null,
            createBy: null,
            createTime : null,
        });
      }
}
export class ShippingArrivalDetailModel extends ShippingArrivalModel {
    courierName : string;
    clientName : string;
    clientComapny : string;
    createByUser : UserModel;

}


export class RmaRequestModel {
    step : number;
    rma : RmaMasterModel;
    client : ClientModel;
    rmaitems : RmaItemExModel[];

    constructor()
    {
        this.rma = new RmaMasterModel();
        this.client = new ClientModel();
        this.rmaitems = new Array<RmaItemExModel>();
    }

    convertToRmaRequestEx()
    {
        var rmaRequest = new RmaRequstExModel();
        rmaRequest.rmaId = this.rma.rmaId;
        rmaRequest.rmaNo = this.rma.rmaNo;
        rmaRequest.rmaType = this.rma.rmaType;
        rmaRequest.rmaCode = this.rma.rmaCode;
        rmaRequest.clientId = this.rma.clientId;
        rmaRequest.clientType = this.rma.clientType;
        rmaRequest.rmaTypeRequested = this.rma.rmaTypeRequested;
        rmaRequest.emailRequested = (this.rma.emailRequestedString == "1");
        rmaRequest.destination = this.rma.destination;
        rmaRequest.shippingAddress = this.rma.shippingAddress;
        rmaRequest.status  = this.rma.status;
        rmaRequest.createBy  = this.rma.createBy;
        rmaRequest.createTime = this.rma.createTime;
        rmaRequest.statusBy  = this.rma.statusBy;
        rmaRequest.statusTime = this.rma.statusTime;

        rmaRequest.rmaItems = new Array<RmaItemModel>();
        for (var i = 0; i < this.rmaitems.length; i++) {
            rmaRequest.rmaItems.push(this.rmaitems[i].rmaitem);
        }
        return rmaRequest;
    }
}

export class RmaMasterModel {
    rmaId : string;
	rmaNo : number;
	rmaType : string;
	rmaCode : string;
	clientId : string;
	clientType: string;
	rmaTypeRequested : string;
    emailRequested : boolean;
    emailRequestedString : string;
    destination : string;
	shippingAddress:string;
    isArrived : boolean;
    arrivalId : string;
	status : string;
    createBy : string;
    createTime: DatePipe;
	statusBy : string;
    statusTime: DatePipe;

    constructor()
    {
        this.rmaId = null;
        this.rmaNo = 0;
        this.rmaType = null;
        this.rmaCode = null;
        this.clientId = null;
        this.clientType = 'C';
        this.rmaTypeRequested = null;
        this.emailRequested = false;
        this.emailRequestedString = "0";
        this.destination  = "CA";
        this.shippingAddress = null;
        this.isArrived = false;
        this.arrivalId = null;
        this.status = 'SS';
        this.createBy = null;
        this.createTime = null;
        this.statusBy = null;
        this.statusTime = null;
    }



}

export class RmaMasterDetailModel extends RmaMasterModel {
    createByUser : UserModel;
    statusByUser: UserModel;
    clientName : string;
    clientCompany : string;
    clientPhone1 : string;
    clientPhone2 : string;
    clientEmail1 : string;
    clientEmail2 : string;
    arrivalDate : DatePipe;
    isStanby : boolean;
    isClosed : boolean;
    comment : RmaCommentModel;
    commentList : RmaCommentModel[];

    constructor()
    {
        super();
        this.comment = new RmaCommentModel();
        this.commentList = new Array<RmaCommentModel>()
    }
}


export class RmaItemModel {
    rmaItemId : string;
    rmaId : string;
    productId : string;
    sn: string;
    snList : string []; // for Stock Rotation
    defect : string;
	purchaseFrom : string;
	purchaseDate : DatePipe;
    invoiceNo :string;
    declined : boolean;
    warranty : boolean;
	warrantyDate : DatePipe;
    status : string;
    createBy : string;
    createTime: DatePipe;

    constructor()
    {
        this.rmaItemId = null;
        this.rmaId = null;
        this.productId = null;
        this.sn = null;
        this.snList = null;
        this.defect = null;
        this.purchaseFrom = null;
        this.purchaseDate = null;
        this.invoiceNo = null;
        this.declined = false;
        this.warranty = false;
        this.warrantyDate = null;
        this.status = "SS";
        this.createBy = null;
        this.createTime = null;
    }

    public static getFormGroup()
    {
        var form: FormGroup = new FormGroup({
            rmaItemId: new FormControl(null),
            rmaId: new FormControl(null),
            productId: new FormControl(null, Validators.required),
            sn :  new FormControl(null),
            snList : new FormControl(null),
            defect: new FormControl(null, Validators.required),
            purchaseFrom: new FormControl(null),
            purchaseDate: new FormControl(null),
            invoiceNo: new FormControl(null, Validators.required),
            warranty: new FormControl(false),
            declined: new FormControl(false),
            warrantyDate: new FormControl(null),
            status: new FormControl(null),
            createBy: new FormControl(null),
            createTime: new FormControl(null)
        });
        return form;
    }

    public static initializeFormGroup(form){

        form.setValue({
            rmaItemId : null,
            rmaId : null,
            productId : null,
            sn: null,
            snList : null,
            defect : null,
            purchaseFrom : null,
            purchaseDate : null,
            invoiceNo : null,
            declined : false,
            warranty : false,
            warrantyDate : null,
            status : null,
            createBy : null,
            createTime: null
        });
      }
}

export class RmaItemDetailModel extends RmaItemModel {
    productName : string;
    warrantyString : string;
    isStanby : boolean;
    isApproved : boolean;
    isTested : boolean;
    comment : RmaCommentModel;
    commentList : RmaCommentModel[];
    commentStatusList : RmaCommentExModel[];
    constructor()
    {
        super();
        this.comment = new RmaCommentModel();
        this.commentList = new Array<RmaCommentModel>()
    }
    static convertToRmaItemWithComment(item)
    {
        var rmaitem = new RmaItemWithCommentModel();
        rmaitem = item;
        rmaitem.warranty = (item.warrantyString == "1");
        rmaitem.comment = item.comment;
        rmaitem.comment.rmaId = item.rmaId;
        rmaitem.comment.rmaItemId = item.rmaItemId;
        rmaitem.comment.status = item.status;
        return rmaitem;
    }
}

export class RmaItemExModel {
    rmaitem : RmaItemModel;
    product : ProductModel;
    constructor()
    {
        this.rmaitem = new RmaItemModel();
        this.product = new ProductModel();

    }
}

export class RmaRequstExModel extends RmaMasterModel
{
    rmaItems : RmaItemModel[];
}

export class RmaItemSNModel
{
    rmaId : string;
    rmaItemId : string;
    sn : string;
}

export class RmaCommentModel
{
    commentId : string;
    rmaId : string;
    rmaItemId : string;
    comment : string;
    status : string;
    flag : boolean;
    createByUser : UserModel;
    createBy : string;
    createTime: DatePipe;
    isEditMode: boolean;
    commentSaved : string;
    constructor(rmaId = null, rmaItemId = null, status = null)
    {
        this.commentId = null;
        this.rmaId = rmaId;
        this.rmaItemId = rmaItemId;
        this.comment = null;
        this.status = status;
        this.flag = false;
        this.createBy = null;
        this.createTime = null;
        this.createByUser = null;
        this.isEditMode = false;
        this.commentSaved  = null;
    }
}

export class RmaCommentExModel extends RmaCommentModel {
    subcomments : RmaCommentModel[];

    constructor(sitem = null)
    {
        super();
        if(sitem != null)
        {
          this.commentId = sitem.commenctId;
          this.rmaId = sitem.rmaId;
          this.rmaItemId = sitem.rmaItemId;
          this.comment = sitem.comment;
          this.status = sitem.status;
          this.flag = sitem.flag;
          this.createBy = sitem.createBy;
          this.createTime = sitem.createTime;
          this.createByUser = sitem.createByUser;
          this.isEditMode = sitem.isEditMode;
          this.commentSaved  = sitem.commentSaved;
        }

        this.subcomments = new Array<RmaCommentModel>();
    }
}

export class RmaItemWithCommentModel extends RmaItemModel {
  comment : RmaCommentModel;

  constructor()
  {
      super();
      this.comment = new RmaCommentModel();
  }
}


export class RmaApprovalModel
{
    clientName : string;
    clientEmail : string;
    rmaCode : string;
    comment : string;
    RmaItems : RmaItemDetailModel[];
}

